export const FEEDBACK_STEP = {
  workplaces: "workplaces",
  workplace: "workplace",
  gotOffer: "got-offer",
  notHeardBack: "not-heard-back",
  notOfferTheRole: "not-offer-the-role",
  notOfferConfirmation: "not-offer-confirmation",
  notInterview: "not-interview",
  notInterviewConfirmation: "not-interview-confirmation",
} as const;
export type FeedbackStep = (typeof FEEDBACK_STEP)[keyof typeof FEEDBACK_STEP];
